import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import SmartSearchSuggestionsFetcher from '@/fetchers/SmartSearchSuggestionsFetcher';

const fallbackSuggestions = [
    'Vehicles with a good price',
    'Cars with clean vehicle history',
    'SUVs with third-row seating under $40,000',
    'Sedans with AWD and leather interior',
    'Sedans under $25,000',
];

const suggestedSearchesDuck = objectDuckCreator({
    store: 'suggestedSearches',
    initialState: {
        suggestions: [],
        isLoading: false,
    },
}).extend({
    creators: () => ({
        loadSuggestions: (params) => async (dispatch) => {
            const { selectedFilterOptions, personalizationData, pixallId, consumerId } = params;

            dispatch(suggestedSearchesDuck.creators.setKeys({
                isLoading: true,
            }));

            try {
                const response = await SmartSearchSuggestionsFetcher({
                    selectedFilterOptions,
                    personalizationData,
                    pixallId,
                    consumerId,
                });

                if (response?.suggestions?.length > 0) {
                    // Map the response structure to extract values and filter out invalid ones
                    const suggestions = response.suggestions
                        .map((suggestion) => suggestion.value)
                        .filter((value) => value && typeof value === 'string' && value.trim() !== '');

                    dispatch(suggestedSearchesDuck.creators.setKeys({
                        isLoading: false,
                        suggestions,
                    }));
                } else {
                    // Empty response, use fallback
                    dispatch(suggestedSearchesDuck.creators.setKeys({
                        isLoading: false,
                        suggestions: fallbackSuggestions,
                    }));
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error fetching suggested searches:', error);
                dispatch(suggestedSearchesDuck.creators.setKeys({
                    isLoading: false,
                    suggestions: fallbackSuggestions,
                }));
            }
        },
        clearSuggestions: () => async (dispatch) => {
            dispatch(suggestedSearchesDuck.creators.setKeys({
                suggestions: [],
                isLoading: false,
            }));
        },
    }),
    selectors: () => ({
        getSuggestions: new DuckSelector((selectors) => createSelector(
            selectors.getDuckState,
            ({ suggestions = [] }) => suggestions,
        )),
        getIsLoading: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isLoading),
    }),
});

export default suggestedSearchesDuck;
